// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";

import * as sharedSelectors from "@modules/shared/selectors";
import actionCreator from "@modules/service/actionCreator";
import * as serviceSelectors from "@modules/service/selectors";
import { HierarchyScopeForm } from "@modules/service/components/hierarchy-scope";
import type { StepProps } from "@components";
import type { Rtw } from "@modules/service/reducer/rtw/types";
import type { HierarchyTree } from "@modules/shared/reducer/hierarchy/types";
import type { HierarchyAssignment } from "@modules/service/types";

type OwnProps = $Exact<{
  editing: boolean,
}>;

type PropsFromState = $Exact<{
  schema: ?Object,
  draft: ?Rtw,
  assignments: Array<HierarchyAssignment>,
  hierarchy: ?HierarchyTree,
}>;

type PropsFromDispatch = $Exact<{
  setAssignments: typeof actionCreator.SetRtwAssignments,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromState,
  ...PropsFromDispatch,
  ...StepProps,
  ...PropsFromLocalize,
}>;

export class StepHierarchyScope extends React.Component<Props> {
  handleChanges = (data: Array<HierarchyAssignment>) => {
    this.props.setAssignments(data);
  };

  render() {
    if (!this.props.editable) {
      return <div />;
    }

    return (
      <div className="w-100 d-flex justify-content-center">
        <div className="col-sm-12">
          {this.props.hierarchy ? (
            <HierarchyScopeForm
              hierarchy={this.props.hierarchy}
              assignments={this.props.assignments}
              onChange={this.handleChanges}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps): PropsFromState => {
  return {
    schema: serviceSelectors.getRtwSchema(state),
    draft: serviceSelectors.getRtwDraft(state),
    assignments: serviceSelectors.getRtwAssignments(state),
    hierarchy: sharedSelectors.getHierarchyTree(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  setAssignments: actionCreator.SetRtwAssignments,
};

export default compose(
  localize(),
  connect(mapStateToProps, mapDispatchToProps),
)(StepHierarchyScope);
